export default __webpack_public_path__ + "static/Category1-962ac441ddbfbf8c876a5c5d6a231495.jpg";